/**
 * Utility functions for handling capability display and search.
 * Capability variants are generated from shared/taxonomy/care_taxonomy.json.
 */
import { CAPABILITY_VARIANTS, TAXONOMY_VERSION } from "../generated/careTaxonomy";

let ACTIVE_CAPABILITY_VARIANTS: Record<string, string[]> = {
  ...CAPABILITY_VARIANTS,
};

export function updateCapabilityVariants(
  backendVariants: Record<string, string[]>
): void {
  ACTIVE_CAPABILITY_VARIANTS = { ...CAPABILITY_VARIANTS, ...backendVariants };
}

export function getCurrentCapabilityVariants(): Record<string, string[]> {
  return { ...ACTIVE_CAPABILITY_VARIANTS };
}

export function getAvailableCapabilities(): string[] {
  return Object.keys(ACTIVE_CAPABILITY_VARIANTS);
}

export function getAllCapabilityVariants(): string[] {
  const allVariants = new Set<string>();
  for (const variants of Object.values(ACTIVE_CAPABILITY_VARIANTS)) {
    variants.forEach((variant) => allVariants.add(variant));
  }
  return Array.from(allVariants).sort();
}

export function getCapabilityVariants(capability: string): string[] {
  return ACTIVE_CAPABILITY_VARIANTS[capability] || [capability];
}

export function getCleanCapabilityName(capability: string): string {
  for (const [cleanName, variants] of Object.entries(ACTIVE_CAPABILITY_VARIANTS)) {
    if (variants.includes(capability)) {
      return cleanName;
    }
  }
  return capability;
}

export function areCapabilityVariants(
  capability1: string,
  capability2: string
): boolean {
  for (const variants of Object.values(ACTIVE_CAPABILITY_VARIANTS)) {
    if (variants.includes(capability1) && variants.includes(capability2)) {
      return true;
    }
  }
  return false;
}

export function getCapabilityTooltip(capability: string): string {
  const variants = ACTIVE_CAPABILITY_VARIANTS[capability];
  if (variants && variants.length > 1) {
    return `Includes: ${variants.join(", ")}`;
  }
  return "";
}

export function formatCapabilityForDisplay(
  capability: string,
  showVariants: boolean = false
): string {
  if (showVariants) {
    const variants = ACTIVE_CAPABILITY_VARIANTS[capability];
    if (variants && variants.length > 1) {
      return `${capability} (${variants.length} variants)`;
    }
  }
  return capability;
}

export function applyCapabilityVariantsFromTaxonomy(
  capabilityVariants: Record<string, string[]>
): void {
  if (capabilityVariants && typeof capabilityVariants === "object") {
    updateCapabilityVariants(capabilityVariants);
  }
}

export function getActiveCapabilityCatalogVersion(): string {
  return TAXONOMY_VERSION;
}
